export interface ContactSaveResponse {
  uid: string;
  telephone: string;
  unifiedTelephone: string;
  default: boolean;
  mergeOutcome?: { merged: boolean; redirectTo?: string };
}

export function contactMergeDestination(
  response: ContactSaveResponse,
): string | null {
  if (!response.mergeOutcome?.merged) return null;
  const destination = response.mergeOutcome.redirectTo;
  return destination && /^\/leads-new\/\d+-[a-zA-Z0-9]{4}$/.test(destination)
    ? destination
    : "/leads";
}

interface ContactErrorBody {
  code?: string;
  message?: string;
  conflictUid?: string;
}
interface ContactError extends ContactErrorBody {
  status?: number;
  data?: ContactErrorBody;
  response?: { status?: number; data?: ContactErrorBody };
}

export function isContactReviewPending(error: unknown): boolean {
  const value = error as ContactError | null;
  const body = value?.response?.data ?? value?.data ?? value;
  return body?.code === "CONTACT_MERGE_BOTH_ACTIVE" && !!body.conflictUid;
}

export function contactSaveError(error: unknown): string {
  const value = error as ContactError | null;
  const body = value?.response?.data ?? value?.data ?? value;
  if (body?.code === "CONTACT_MERGE_BOTH_ACTIVE")
    return `Both leads are active. Please contact Operations to resolve the duplicate. ${isContactReviewPending(error) ? "Your request has been saved for review." : "No changes were saved."}`;
  if (body?.code === "CONTACT_MERGE_RETRY")
    return "Customer contacts changed. Please try again.";
  const status = value?.status ?? value?.response?.status;
  if (status === 403)
    return "You do not have permission to update this lead's contacts.";
  if (status === 409)
    return (
      body?.message ||
      "This phone number is already linked to a customer. Review the duplicate before merging."
    );
  return "Could not add the phone number. Please try again.";
}
